import { render, staticRenderFns } from "./StatisticFilter.vue?vue&type=template&id=99df60b8&scoped=true"
import script from "./StatisticFilter.vue?vue&type=script&lang=ts"
export * from "./StatisticFilter.vue?vue&type=script&lang=ts"
import style0 from "./StatisticFilter.vue?vue&type=style&index=0&id=99df60b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99df60b8",
  null
  
)

export default component.exports